import {DefaultResType} from "../../types/common/response";
import {baseApi} from "../../util/axiosConfig";
import {
    DashboardSettingListElementType,
    DashboardSettingSearchParamType
} from "../../pages/main/dashboard/detail/interface";

const url = "api/home/dashboard/";

export async function readOrderStatus(): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "read_order_status");
    } catch (err: any) {
        return err?.response;
    }
}

export async function readDashboardSetting(param: DashboardSettingSearchParamType): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "read_dashboard_setting", param);
    } catch (err: any) {
        return err?.response;
    }
}

export async function updateDashboardHiddenSetting(param: DashboardSettingListElementType[]): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "update_dashboard_hidden_setting", param);
    } catch (err: any) {
        return err?.response;
    }
}

export async function updateInitialDashboardSetting(): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "update_initial_dashboard_setting");
    } catch (err: any) {
        return err?.response;
    }
}

export async function updateDashboardOrderSetting(data: DashboardSettingListElementType[]): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "update_dashboard_order_setting", data);
    } catch (err: any) {
        return err?.response;
    }
}

// 아이템 별 조회
export async function readRevenueByItem(): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "read_revenue_by_item");
    } catch (err: any) {
        return err?.response;
    }
}

// Veritcal 별 조회
export async function readRevenueByVertical(): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "read_revenue_by_vertical");
    } catch (err: any) {
        return err?.response;
    }
}


// 팀 전년 매출/목표 조회
export async function readRevenueByTeamByLastYear(): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "read_revenue_by_team_by_last_year");
    } catch (err: any) {
        return err?.response;
    }
}

// 팀 분기 매출/목표 조회
export async function readRevenueByTeamByQuarter(): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "read_revenue_by_team_by_quarter");
    } catch (err: any) {
        return err?.response;
    }
}

// 팀 올해 매출/목표 조회
export async function readRevenueByTeamByYear(): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "read_revenue_by_team_by_year");
    } catch (err: any) {
        return err?.response;
    }
}

// 팀 월별 매출/목표 조회
export async function readRevenueByTeamByMonth(): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "read_revenue_by_team_by_month");
    } catch (err: any) {
        return err?.response;
    }
}

// 담당자 별 당월 매출/목표 조회
export async function readRevenueByHandlerByMonth(): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "read_revenue_by_handler_by_month");
    } catch (err: any) {
        return err?.response;
    }
}

// 담당자 별 연간 매출/목표 조회
export async function readRevenueByHandlerByYear(): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "read_revenue_by_handler_by_year");
    } catch (err: any) {
        return err?.response;
    }
}

// 본인 월별 매출/목표 조회
export async function readRevenueByUserByMonth(): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "read_revenue_by_user_by_month");
    } catch (err: any) {
        return err?.response;
    }
}


// 본인 전년 매출/목표 조회
export async function readRevenueByUserByLastYear(): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "read_revenue_by_user_by_last_year");
    } catch (err: any) {
        return err?.response;
    }
}


// 본인 올해 매출/목표 조회
export async function readRevenueByUserByYear(): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "read_revenue_by_user_by_year");
    } catch (err: any) {
        return err?.response;
    }
}